import request from '@/utils/request';

export function zcCommit(url, obj) {
    return request({
        url: url,
        method: 'post',
        data: obj
    })
}
export function loginCommit(url){
    return request({
        url:url,
        method:'get'
    })
}
export function getUser(url){
    return request({
        url:url,
        method:'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/jjdt/jjdt.js